<div class="u-text-center">
  <app-loader></app-loader>
  <p nxCopytext="normal">{{ 'load-policy-data.loading' | translate }} {{policyNumber || leadId}}</p>
</div>
